import { ArgumentError } from '../utils/errors';
import ImageUploadConfigModel from './imageUploadConfig';
import { fetcher } from '@weezevent/weezjs-core';

export default class UploadRequestPartnerConfigModel extends ImageUploadConfigModel {
    static PROCESS = 'partner-import';

    uploadConfig({ organizationId, datas = {}, name = '' }) {
        let url = `/ticket/organizations/${organizationId}/partners/import/config`;
        if (name) {
            url += `?name=${name}`;
        }
        return fetcher.post(url).then(({ response }) => {
            this.upload_config = response;
            this.data = datas;
            return this;
        });
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][UploadRequest][getAll] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/partners/import`;
    }
}
